import { CalendarBlank, CalendarIcon, TrifoldMapIcon } from "../../../icons";
import clsx from "clsx";
import { SortDropdown } from "../../../components/service/NewServiceBooking/SortDropdown";
import { toast } from "../../../components/ui/Toast/useToast";
import { size } from "lodash";
import { useOptionSelection } from "../../../hooks/react-query/useNewService";
import { buildGaragesCalendar, getTimeslotWindow, undoUntil } from "../serviceUtils";
import Loader from "../../../components/elements/loader";
import { useEffect, useState } from "react";

export const GarageAvailabilityList = ({ state, dispatch, mode="FirstAvailableAvis" }) => {

  // LOCAL STATE: 
  const [isUndoLoading, setIsUndoLoading] = useState(false)

  // FETCH DATA:

  // LOCAL VARIABLES:
  const { mutate: optionSelect, isLoading: isOptionSelectionLoading} = useOptionSelection()
  
  // USE EFFECTS:

  // HANDLERS & FUNCTIONS
  const toggleAvailabilityOption = async () => {
    setIsUndoLoading(true)
    
    if(state?.stepThree === 'NearestAvis') {
      const payload = { optionSelection: "FirstAvailableAvis" }
      try{
        const undoStatus = await undoUntil({targetStep:"optionSelection", state, dispatch})
        // clearSBStepStatusState({targetStepStatus: "location", dispatch})
        
        if(!undoStatus?.success) {
          toast({
            variant: 'destructive',
            description: undoStatus?.message,
          });
          setIsUndoLoading(false)
        } else { // handle no exceptions
          setIsUndoLoading(false)
          optionServiceHandler({
            payload,
            successOps: (response) => {
              const bookingSelectOptions =
                response?.inputs?.bookingSelect?.options || [];

              const bookingCalendarOptions =
                response?.inputs?.bookingCalendar?.options || [];

              const normalized = buildGaragesCalendar(
                bookingSelectOptions,
                bookingCalendarOptions
              );
              const preselectedDate = new Date(normalized?.[0]?.calendarData?.[0]?.startTime)
              dispatch({ type: 'CLEAR_TIMESLOTS' })
              dispatch({ type: "SET_GARAGE_CALENDAR_DATA", garageCalendarData: normalized})
              dispatch({ type: "SET_SELECTED_GARAGE", selectedGarage: normalized?.[0]})
              dispatch({ type: 'SET_SELECTED_DATE', value: preselectedDate })
              dispatch({ 
                type: "ADD_TIMESLOT", 
                value: getTimeslotWindow({
                  slot: normalized?.[0]?.calendarData?.[0], 
                  dateKey: preselectedDate.toLocaleDateString('en-CA')
                })
              })
              dispatch({ type: "SET_STEP_THREE", stepThree: "FirstAvailableAvis"});
              dispatch({ type: 'SET_STEPSTATUS', stepStatus: response?.name });
            }
          })
        }
      } catch(e) {
        setIsUndoLoading(false)
        console.warn(e)
      }
    }
      
    if(state?.stepThree === 'FirstAvailableAvis') {
      const payload = { optionSelection: "NearestAvis" }
      try {
        const undoStatus = await undoUntil({targetStep:"optionSelection", state, dispatch})
        // clearSBStepStatusState({targetStepStatus: "location", dispatch})
        if(!undoStatus?.success) {
          toast({
            variant: 'destructive',
            description: undoStatus?.message,
          });
          setIsUndoLoading(false)
        } else { // handle no exceptions
          setIsUndoLoading(false)
          optionServiceHandler({
            payload,
            successOps: (response) => {
              const bookingSelectOptions =
                response?.inputs?.bookingSelect?.options || [];

              const bookingCalendarOptions =
                response?.inputs?.bookingCalendar?.options || [];

              const normalized = buildGaragesCalendar(
                bookingSelectOptions,
                bookingCalendarOptions
              );
              const preselectedDate = new Date(normalized?.[0]?.calendarData?.[0]?.startTime)
              dispatch({ type: 'CLEAR_TIMESLOTS' })
              dispatch({ type: "SET_GARAGE_CALENDAR_DATA", garageCalendarData: normalized})
              dispatch({ type: "SET_SELECTED_GARAGE", selectedGarage: normalized?.[0]})
              dispatch({ type: 'SET_SELECTED_DATE', value: preselectedDate })
              dispatch({ 
                type: "ADD_TIMESLOT", 
                value: getTimeslotWindow({
                  slot: normalized?.[0]?.calendarData?.[0], 
                  dateKey: preselectedDate.toLocaleDateString('en-CA')
                })
              })
              dispatch({ type: "SET_STEP_THREE", stepThree: "NearestAvis"});
              dispatch({ type: 'SET_STEPSTATUS', stepStatus: response?.name });
            }
          })
        }
      } catch (e) {
        setIsUndoLoading(false)
        console.warn(e)
      }
    }
  }

  const optionServiceHandler = ({payload, successOps}) => {
    try{
        optionSelect({payload, serviceFlowId:state?.serviceFlowId },
        {
          onSuccess : (response) => {
            if (response && response.exceptions) {
              if (size(response.exceptions) > 0) {
                toast({
                  variant: 'destructive',
                  description: 'Παρουσιάστηκε κάποιο πρόβλημα',
                });
              }
            } else { // handle no exceptions
              successOps(response)
            }
          }
        }
      )} catch(e) {
        console.warn(e)
        toast({
          variant: 'destructive',
          description: 'Παρουσιάστηκε κάποιο πρόβλημα',
        });
      }
  }

  return (
    <div className='flex flex-col pb-8'>
      {(isOptionSelectionLoading || isUndoLoading) && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/20 backdrop-blur-[2px]">
          <Loader />
        </div>
      )}
      <div className={`shadow-md rounded-xl py-6 px-9 bg-white`}>
        <div className='flex flex-row max-lg:flex-col max-lg:gap-3 max-lg:items-start items-center justify-between pb-6'>
          <h3>Επίλεξε το ραντεβού που σε εξυπηρετεί:</h3>
          {(mode !== "PickupAvis" && mode !== "CRMForm") && state?.garageCalendarData?.length > 1 && <SortDropdown
            state={state}
            disabled={
              !state?.stepThreeOptions?.availabilityOptions?.includes("NearestAvis")
            }
            onChange={() => {
              toggleAvailabilityOption()
            }}
          />}
        </div>
        <div className='flex flex-col gap-3 w-full'>
          {state?.garageCalendarData?.map((garage)=>{
            const date = new Date(garage?.calendarData?.[0]?.startTime);
            const weekday = date
              .toLocaleDateString("el-GR", { weekday: "long" })
              .replace(/^./, c => c.toUpperCase());
            const dayMonth = date.toLocaleDateString("el-GR", {
              day: "2-digit",
              month: "2-digit",
            });
            const time = date.toLocaleTimeString("el-GR", {
              hour: "2-digit",
              minute: "2-digit",
              hour12: false,
              timeZone: "Europe/Athens",
            });
            const formatted = ( !weekday.includes('Invalid Date') && 
            !dayMonth.includes('Invalid Date') && 
            !time.includes('Invalid Date') ) ? 
            `${weekday} ${dayMonth} ${time}` :"-";
            return (
              <div key={garage} className={`flex flex-col border ${(garage?.calendarData?.length > 0 || mode === "CRMForm") ? 'hover:border-black' : "cursor-not-allowed"} ${garage === state?.selectedGarage ? "border-black outline outline-1 outline-black" : "border-fadedgrey"} rounded-xl p-5`}
                onClick={()=>{
                  dispatch({ type: "SET_SELECTED_GARAGE", selectedGarage: garage})
                  if(mode !== "CRMForm" && garage?.calendarData?.length > 0) { 
                    dispatch({ type: 'CLEAR_TIMESLOTS' })
                    dispatch({ type: 'SET_SELECTED_DATE', value: new Date(garage?.calendarData?.[0]?.startTime)})
                    dispatch({ 
                      type: "ADD_TIMESLOT", 
                      value: getTimeslotWindow({
                        slot: garage?.calendarData?.[0], 
                        dateKey: new Date(garage?.calendarData?.[0]?.startTime).toLocaleDateString('en-CA')
                      })
                    })
                  }
                  if(mode === "PickupAvis" && garage?.calendarData?.length > 0) {
                    dispatch({ type: "SET_STEP_THREE", stepThree: "PickupAvis"});
                  }
                  if(mode === "CRMForm") {
                    dispatch({ type: "SET_STEP_THREE", stepThree: state?.selectedPickup ? "PickupCRMForm" : "CRMForm"});
                  }
                }}>
                <h4 className={`cursor-default ${mode === "PickupAvis" && garage?.calendarData?.length < 1 && "text-fadedgrey"}`}>{garage?.garageName || "Όνομα Συνεργείου"}</h4>
                <div className={`flex flex-row justify-between items-end max-lg:flex-col max-lg:gap-4 max-lg:items-start`}>
                  <div className='flex flex-col gap-2'>
                    <p className='text-sm cursor-default'>{garage?.address}</p>
                    <div className="flex flex-row gap-4">
                      <button 
                        disabled={!state?.selectedGarage}
                        className='bg-none flex flex-row gap-2 items-center'
                        onClick={()=>{
                          const googleMapsUrl = `https://www.google.com/maps/place/${garage?.coordinates?.lat},${garage?.coordinates?.lng}`
                          window.open(googleMapsUrl, "_blank", "noopener,noreferrer");           
                        }}>
                          <TrifoldMapIcon className={`w-4 h-4 ${state?.selectedGarage ? "text-primary " : "text-fadedgrey"}`} />
                          <p className={`text-sm ${state?.selectedGarage ? "text-primary " : "text-fadedgrey"} font-semibold`}>Δες το στον χάρτη</p>
                      </button>
                      {garage?.distanceFromUser && <p className="text-sm text-grenite">{(garage?.distanceFromUser/1000).toFixed(1)} km</p>}
                    </div>
                  </div>
                  {mode !== "PickupAvis" && mode!== "CRMForm" && <div className='flex flex-col gap-2 justify-center items-center'>
                    <div className='flex flex-row justify-center items-center gap-2 py-2 px-4 bg-powdergrey rounded-full'>
                      <CalendarBlank className={clsx('h-5 w-5', 'stroke-black')} />
                      <p className='text-sm cursor-default'>{formatted}</p>
                    </div>
                    <button
                      disabled={garage?.calendarData?.length < 2}
                      className='bg-none flex flex-row gap-2 items-center' 
                      onClick={()=>{
                        dispatch({ type: "SET_SELECTED_GARAGE", selectedGarage: garage})
                        dispatch({ type: 'CLEAR_TIMESLOTS' })
                        dispatch({ type: 'SET_SELECTED_DATE', value: new Date(garage?.calendarData?.[0]?.startTime)})
                        dispatch({ 
                          type: "ADD_TIMESLOT", 
                          value: getTimeslotWindow({
                            slot: garage?.calendarData?.[0], 
                            dateKey: new Date(garage?.calendarData?.[0]?.startTime).toLocaleDateString('en-CA')
                          })
                        })
                        dispatch({ type: "SET_CALENDAR_DATA", calendarData: garage?.calendarData});
                        dispatch({ type: "SET_STEP_THREE", stepThree: "FirstAvailableAvisCalendar"});
                      }}>
                        <p className={`text-sm ${garage?.calendarData?.length > 1 ? "text-primary " : "text-fadedgrey"} font-semibold`}>Άλλη διαθεσιμότητα</p>
                    </button>
                  </div>}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  );
};
